export class Login{

    userName:string;
    group:string;
    loginTime:string
    logoutTime:string
    uniqueId:string
    centerName:string
}